(() => {
  const playIcon = '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M8 5.5v13l11-6.5z" fill="currentColor"/></svg>';
  const pauseIcon = '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z" fill="currentColor"/></svg>';
  const fmt = seconds => {
    const value = Math.max(0, Math.round(Number.isFinite(seconds) ? seconds : 0));
    return Math.floor(value / 60) + ':' + String(value % 60).padStart(2, '0');
  };
  function initialize(root) {
    if (root.dataset.songReady === 'yes') return;
    root.dataset.songReady = 'yes';
    const eventHook = event => window.dispatchEvent(new CustomEvent('songbond:gift-example', {
      detail: { event, page: root.dataset.songHandle, gift_intent: root.dataset.giftIntent }
    }));
    root.querySelectorAll('[data-song-event="create_click"]').forEach(link => {
      link.addEventListener('click', () => eventHook('create_click'));
    });
    const player = root.querySelector('[data-song-player]');
    if (player) {
      const audio = player.querySelector('audio');
      const play = player.querySelector('[data-song-play]');
      const back = player.querySelector('[data-song-back]');
      const forward = player.querySelector('[data-song-forward]');
      const seek = player.querySelector('[data-song-position]');
      const elapsed = player.querySelector('[data-song-elapsed]');
      const duration = player.querySelector('[data-song-duration]');
      const status = player.querySelector('[data-song-audio-status]');
      if (audio && play && back && forward && seek && elapsed && duration && status) {
        let dragging = false;
        let pointerId = null;
        let scrub = null;
        const getTotal = () => Number.isFinite(audio.duration) && audio.duration > 0 ? audio.duration : 0;
        function syncPosition() {
          const total = getTotal();
          const shown = scrub ?? audio.currentTime;
          const pct = total ? Math.max(0, Math.min(1, shown / total)) * 100 : 0;
          duration.textContent = total ? fmt(total) : '–:––';
          elapsed.textContent = fmt(shown);
          seek.querySelector('i').style.width = pct + '%';
          seek.querySelector('b').style.left = pct + '%';
          seek.setAttribute('aria-valuemax', String(total ? Math.round(total) : 0));
          seek.setAttribute('aria-valuenow', String(Math.round(shown)));
          seek.setAttribute('aria-valuetext', total ? player.dataset.positionTemplate.replace('__ELAPSED__', fmt(shown)).replace('__TOTAL__', fmt(total)) : fmt(shown));
          seek.setAttribute('aria-disabled', String(!total));
          back.disabled = !total;
          forward.disabled = !total;
        }
        function syncPlayback() {
          play.innerHTML = audio.paused ? playIcon : pauseIcon;
          play.setAttribute('aria-label', audio.paused ? player.dataset.playLabel : player.dataset.pauseLabel);
        }
        function seekTo(seconds) {
          const total = getTotal();
          if (!total || !Number.isFinite(seconds)) return;
          audio.currentTime = Math.max(0, Math.min(total, seconds));
          syncPosition();
        }
        function fromPointer(clientX) {
          const total = getTotal();
          if (!total) return null;
          const box = seek.getBoundingClientRect();
          if (box.width <= 0) return null;
          return Math.max(0, Math.min(1, (clientX - box.left) / box.width)) * total;
        }
        function finishDrag(event, commit) {
          if (!dragging || event.pointerId !== pointerId) return;
          dragging = false;
          pointerId = null;
          try { seek.releasePointerCapture(event.pointerId); } catch {}
          const value = commit ? fromPointer(event.clientX) : null;
          scrub = null;
          seek.classList.remove('is-drag');
          if (value !== null) seekTo(value);
          else syncPosition();
        }
        play.addEventListener('click', async () => {
          try {
            if (audio.paused) {
              if (audio.ended) audio.currentTime = 0;
              await audio.play();
              status.hidden = true;
            } else audio.pause();
          } catch { status.hidden = false; }
        });
        back.addEventListener('click', () => seekTo(audio.currentTime - 15));
        forward.addEventListener('click', () => seekTo(audio.currentTime + 15));
        seek.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          const value = fromPointer(event.clientX);
          if (value === null) return;
          dragging = true;
          pointerId = event.pointerId;
          seek.setPointerCapture(event.pointerId);
          scrub = value;
          seek.classList.add('is-drag');
          syncPosition();
        });
        seek.addEventListener('pointermove', event => {
          if (!dragging || event.pointerId !== pointerId) return;
          const value = fromPointer(event.clientX);
          if (value !== null) { scrub = value; syncPosition(); }
        });
        seek.addEventListener('pointerup', event => finishDrag(event, true));
        seek.addEventListener('pointercancel', event => finishDrag(event, false));
        seek.addEventListener('lostpointercapture', event => finishDrag(event, false));
        seek.addEventListener('keydown', event => {
          if (['ArrowLeft', 'ArrowDown'].includes(event.key)) seekTo(audio.currentTime - 5);
          else if (['ArrowRight', 'ArrowUp'].includes(event.key)) seekTo(audio.currentTime + 5);
          else if (event.key === 'Home') seekTo(0);
          else return;
          event.preventDefault();
        });
        audio.addEventListener('loadedmetadata', syncPosition);
        audio.addEventListener('durationchange', syncPosition);
        audio.addEventListener('timeupdate', syncPosition);
        audio.addEventListener('play', () => { syncPlayback(); eventHook('audio_play'); });
        audio.addEventListener('pause', syncPlayback);
        audio.addEventListener('ended', () => { syncPosition(); syncPlayback(); eventHook('audio_complete'); });
        audio.addEventListener('error', () => { status.hidden = false; });
        syncPosition();
        syncPlayback();
        player.classList.add('is-ready');
      }
    }

  }
  const initializeAll = container => container.querySelectorAll('.sb-song[data-song-page]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(document), { once: true });
  else initializeAll(document);
  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
})();
